export const HOME = "/";
export const ABOUT = "/about-us";
export const HELP = "/help";
export const BLOG = "/blog";
export const ADOPTION = "/adoption";
export const ADMIN = "/apanel";
export const LOGIN = "/login";